import { Box, Container, Stack, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";

export default function UnauthenticatedRoot() {
  return (
    <>
      <Container maxWidth={false} disableGutters>
        <Box>
          <Outlet />
        </Box>
        <Stack width="100%" direction="row" position="fixed" bottom="0" bgcolor="#f7f7f7" py={1} px={{ xs: 1, sm: 6 }}>
          <Typography variant="body2">Powered by <em><b>WUSH</b></em> © 2024</Typography>
        </Stack>
      </Container>
    </>
  );
}